import React from 'react'

function Features() {
  const features = [
    {
      icon: (
        <svg className="w-6 h-6 text-cp-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
        </svg>
      ),
      title: "Companion Matching",
      description: "Connect with caring companions who treat your family like their own"
    },
    {
      icon: (
        <svg className="w-6 h-6 text-cp-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
        </svg>
      ),
      title: "Family-Level Care",
      description: "Professional support with the warmth and dedication of family"
    },
    {
      icon: (
        <svg className="w-6 h-6 text-cp-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
        </svg>
      ),
      title: "Trusted & Verified",
      description: "Thoroughly screened companions with background checks and references"
    }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 max-w-4xl mx-auto animate-fade-in">
      {features.map((feature, index) => (
        <div 
          key={index}
          className="bg-white/70 backdrop-blur-sm rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
          style={{ animationDelay: `${index * 0.2}s` }}
        >
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-4 ${
            index === 0 ? 'bg-cp-primary/10' : 
            index === 1 ? 'bg-cp-secondary/10' : 'bg-cp-primary/10'
          }`}>
            {feature.icon}
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
          <p className="text-gray-600 text-sm">{feature.description}</p>
        </div>
      ))}
    </div>
  )
}

export default Features